module.exports = __webpack_public_path__ + "img/HG4101-01.b91a13ef.jpg";